"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var CheckboxHeaderComponent = function (_a) {
    var grid = _a.grid, _b = _a.checked, checked = _b === void 0 ? false : _b, onChange = _a.onChange, allValues = _a.allValues, _c = _a.cellWidth, cellWidth = _c === void 0 ? false : _c;
    var input = react_1["default"].createElement("input", { type: "checkbox", name: "row-is-selected", value: allValues, checked: checked, onChange: onChange });
    return (react_1["default"].createElement("th", { className: "text-center" }, cellWidth ? (react_1["default"].createElement("div", { style: { 'width': cellWidth } }, input)) : input));
};
exports["default"] = CheckboxHeaderComponent;
